import { render } from "./htmlAudio.vue?vue&type=template&id=56baed2b"
import script from "./htmlAudio.vue?vue&type=script&lang=js"
export * from "./htmlAudio.vue?vue&type=script&lang=js"

import "./htmlAudio.vue?vue&type=style&index=0&id=56baed2b&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__